
import { Component, Vue } from 'vue-property-decorator';

import { sharedState } from '../../../../framework/state';

import { getResourcesNew } from '../../../../framework/client/resource';
import { dateToUiDateTimeString } from '../../../../../common/framework/util/convert';
import ScheduledTask from '../../../../../common/framework/model/ScheduledTask';
import { FrameworkResource } from '../../../../../common/framework/enumeration/FrameworkResource';
import { PAGE_SIZE } from '../../../../../common/framework/constants';

@Component
export default class ScheduledTasks extends Vue {
    readonly resourceType = FrameworkResource.SCHEDULED_TASK;

    shared = sharedState;
    local = {
        rows: [] as ScheduledTask[],
        total: 0,
        loading: false,
        page: 1,
        selected: undefined as ScheduledTask | undefined,
        perPage: PAGE_SIZE,
    };

    async mounted() {
        await this.loadAsyncData();
    }

    async loadAsyncData() {
        this.local.loading = true;
        this.local.rows = [];
        const rows = (await getResourcesNew(this.resourceType, this.local.page - 1)) as ScheduledTask[];

        rows.forEach((row) => {
            this.local.rows.push(row);
        });

        this.local.total = rows.length;

        this.local.loading = false;
        if (this.local && this.local.rows.indexOf(this.local.selected!!) == -1) {
            this.local.selected = undefined;
        }
    }

    dateTimeToString(timestamp: Date) {
        return dateToUiDateTimeString(timestamp);
    }

    getDuration(row: ScheduledTask): string {
        if (!row.ended || !row.started) {
            return '-';
        }

        const diffInMS = new Date(row.ended).getTime() - new Date(row.started).getTime();
        return `${diffInMS / 1000} s`;
    }

    onRowClick(row: ScheduledTask): void {
        if (this.local.selected && row.id === this.local.selected.id) {
            this.local.selected = undefined;
        }
    }
}
